import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reCalculationCostLabel: {
		id: 'servicedesk-sla-settings.common.recalculation-warning-message.recalculation-warning-info.re-calculation-cost-label',
		defaultMessage: 'SLA edits can take time to effect',
		description: 'section message displayed for editing sla configuration',
	},
	reCalculationCostWarningInfoMessage: {
		id: 'servicedesk-sla-settings.common.recalculation-warning-message.recalculation-warning-info.re-calculation-cost-warning-info-message',
		defaultMessage:
			'The SLA for each related issue needs recalculation. During this time, SLAs and reports may not be accurate.',
		description: 'warning message displayed when editing sla configuration impact reports',
	},
});
